import {html, css, SoloLitElement, ifDefined} from '@core/solo-lit-element';

import '@bog-design-system/bd-app-header';
import '@bog-design-system/bd-header-dropdown';
import '@bog-design-system/bd-account-switcher';
import '@bog-design-system/bd-font';
import '@bog-design-system/bd-list-item';
import '@bog-design-system/bd-currency-card';
import '@bog-design-system/bd-icon';
import '@bog-design-system/bd-drawer';
import '@bog-design-system/bd-language-selector';
import '@bog-design-system/bd-product-switcher';
import '@bog-design-system/bd-major-card';
import '@bog-design-system/bd-toggle';
import '@bog-design-system/bd-standard-button';
import '@bog-design-system/bd-button';

import config from '../../config/config';
import '@common/auth/solo-auth-iframe';

export class SoloHeaderWrapper extends SoloLitElement {
  static get is() {
    return 'solo-header-wrapper';
  }

  static get styles() {
    return css`
        :host {
            display: contents;
        }

        .banner-wrapper {
            margin-left: var(--space-24);
        }

        .banner {
            --width: 377px;
            --media-width: 168px;
            --media-height: 108px;
            --background-color: var(--color-invert-background-solid-30);
            --border-color: transparent;
            --layer-alpha-hover-01: transparent;
            --layer-alpha-pressed-01: transparent;
        }

        .banner[type='right'] {
            --width: 445px;
        }

        .banner-title {
            color: var(--color-invert-component-tr-20);
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }

        .banner-description {
            color: var(--color-invert-component-tr-30);
            line-height: var(--space-20);
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
        }

        .content {
            color: var(--color-invert-component-tr-20);
        }

        .item-icon {
            height: 24px;
            width: 24px;
            padding: 4px;
            box-sizing: border-box;
            margin-right: 16px;
            color: var(--color-invert-component-tr-30);
        }

        .right-icon {
            color: var(--color-invert-component-tr-30);
        }

        bd-app-header {
            --header-drawer-width: 60%;
            --app-max-width: 1296px;
            top: -78px;
            --header-z-index: 1000;
            --max-width-top-center: 640px;
            --search-flex-grow: 0;
        }

        a[slot="logo"] {
            width: max-content;
        }

        .app-header-menu-item {
            margin-right: 0;
            padding-right: var(--space-32);
            --color-orange: var(--color-primary-solid-20);
        }

        .menu-overlay {
            --padding: var(--space-32) var(--space-36) var(--space-40);
            --overlay-menu-padding: var(--space-32) var(--space-36) var(--space-40);
            --overlay-desktop-height: auto;
            --grid-template-columns: 1fr;
            --title-margin: 0 0 var(--space-8) 0;
            --grid-gap: var(--space-24);
            --border-radius: 0 0 var(--border-radius-38) var(--border-radius-38);
            --overlay-bg-color: var(--color-black-tr-50);
            min-width: 608px;
            min-height: 308px;
            --max-width: auto;
        }

        .menu-overly-with-banner {
            min-width: 1077px;
        }

        .col-2 {
            --grid-template-columns: repeat(2, 1fr);
        }

        .col-3 {
            --grid-template-columns: repeat(3, 1fr);
            --grid-gap: var(--space-32) var(--space-24);
        }

        .col-4 {
            --grid-template-columns: repeat(4, 1fr);
            --grid-gap: var(--space-32) var(--space-24);
            max-width: 100%;
            right: 0;
        }

        .col-3.menu-overly-with-banner {
            --grid-gap: var(--space-32);
            min-width: 100%;
            right: 0;
        }

        .li-item-wrapper {
            margin-bottom: var(--space-4);
        }

        .li-item {
            --padding-left: 0;
            --padding-right: 0;
            --li-min-height: var(--space-20);
            min-width: 242px;
            padding: var(--space-6) var(--space-16);
            border-radius: var(--border-radius-6);
        }

        .overlay-title-item {
            --li-bg: transparent;
            --item-border-color: transparent;
            min-height: var(--space-48);
            color: var(--color-invert-component-tr-20);
            margin: 0;
            min-width: unset;
        }

        .title-right-icon {
            margin-left: var(--space-12);
            height: var(--space-16);
            width: var(--space-16);
            padding: var(--space-4);
            color: var(--color-invert-component-tr-20);
            transition: transform 0.3s ease;
        }

        .overlay-title-item:hover .title-right-icon {
            transform: translateX(10px);
        }

        .menu-overlay bd-app-header-menu-overlay-column {
            margin-right: 0;
            --padding-left: var(--space-16);
            --title-margin: var(--space-8) 0 var(--space-12) 0;
            --list-margin-bottom: var(--space-4);
        }

        .all-product-button {
            margin: var(--space-8) 0;
        }

        .overlay-button {
            margin: var(--space-8) 0;
        }

        .mega-menu-item {
            text-decoration: none;
            color: var(--color-invert-component-tr-20);
        }

        .selected {
            color: var(--color-primary-solid-20);
        }

        .ibank-link-item {
            --li-min-height: 40px;
        }

        a {
            text-decoration: none;
        }

        .menu-item-title {
            --border-color: transparent;
        }

        .all-button-wrapper {
            display: flex;
            padding-left: var(--space-24);
            height: var(--space-48);
            border-bottom: 1px solid var(--color-invert-component-tr-70);
        }

        .account-switcher {
            align-items: flex-end;
            margin-left: var(--space-32);
        }

        .floating-button {
            display: none;
        }

        .product-switcher {
            display: inline-flex;
            --text-primary: var(--color-invert-component-tr-20);
            --text-secondary: var(--color-invert-component-tr-40);
        }

        .left-items-container {
            display: flex;
            flex-direction: column;
            gap: var(--space-4);
            margin-top: var(--space-8);
        }

        .top-left-item {
            --text-color-dropdown-active: var(--color-primary-solid-40);
        }

        .language-selector {
            margin: 0 var(--space-16);
        }

        @media (max-width: 1300px) {
            bd-app-header {
                --max-width-top-center: 520px;
            }
        }

        @media (max-width: 1220px) {
            .menu-overly-with-banner {
                min-width: 100%;
                right: 0;
            }

            .col-4 {
                --grid-template-columns: repeat(3, 1fr);
            }

            bd-app-header {
                --max-width-top-center: 315px;
            }
        }

        @media (max-width: 1024px) {
            bd-app-header-menu-item[overlay-is-adaptive] {
                position: static;
            }

            .menu-overlay {
                min-width: 100%;
                right: 0;
            }
        }

        @media (max-width: 768px) {
            .account-switcher {
                margin-left: var(--space-32);
            }

            .app-header-menu-item {
                --border-radius-12: var(--border-radius-32);
                margin: 0 var(--space-16);
                padding-right: 0;
            }

            .menu-child-item {
                --item-border-color: transparent;
                margin-bottom: var(--space-4);
                padding: 0 var(--space-24) 0 var(--space-48);
                min-height: 42px;
                --li-bg-hover: transparent;
            }

            .menu-child-item:hover {
                color: var(--color-primary-solid-10);
            }

            .menu-item-title {
                --item-border-color: transparent;
                --padding-left: var(--space-24);
                --padding-right: var(--space-24);
            }

            .all-button-wrapper {
                height: fit-content;
            }

            .all-button {
                --height: fit-content;
            }

            .all-button-icon {
                color: var(--color-invert-component-tr-30);
            }

            .additional-button {
                display: flex;
                margin: var(--space-8) var(--space-16);
            }


            .language-selector {
                margin: 0;
            }

            .lang-item {
                --item-border-color: transparent;
                width: 100%;
                padding: var(--space-8) 0;
            }

            .lang-icon {
                padding: var(--space-12);
                background-color: var(--color-invert-component-tr-80);
                color: var(--color-invert-component-tr-30);
                border-radius: var(--border-radius-circle);
                margin-right: var(--space-8);
            }
        }

        .product-switcher {
            display: inline-flex;
            --text-primary: var(--color-invert-component-tr-20);
            --text-secondary: var(--color-invert-component-tr-40);
        }

        @media (max-width: 600px) {
            .header {
                transition: transform 0.6s ease-in-out;
                position: fixed;
                top: 0;
            }

            :host([header-fixed]) .header {
                position: fixed;
                top: unset;
            }

            :host([hide-header]) .header {
                transform: translateY(-64px);
            }

            .account-switcher {
                align-items: flex-end;
                margin-left: var(--space-24);
            }

            .floating-button {
                display: flex;
                width: 100%;
                border-radius: 0;
            }

            .become-solo-button {
                display: none;
            }
        }

        @media (max-width: 400px) {
            .account-switcher {
                align-items: flex-end;
                margin-left: var(--space-24);
            }
        }

        @media (max-width: 320px) {
            .account-switcher {
                margin-left: var(--space-8);
            }
        }
    `;
  };

  get _isMenuAlreadyActive() {
    const pathArr = window.location.pathname.split('/');
    return this.isMobile &&
      (pathArr.length > 3) &&
      !(window.location.href.includes('main') || window.location.href.includes('about-us'));
  }

  render() {
    return html`
        <solo-auth-iframe></solo-auth-iframe>
        <bd-app-header
                class="header"
                selected="${this.routeElement}"
                mini-search
                main-caption="${this.accountDictionary?.goBack ?? ''}"
                ?hide-bottom="${!this.subMenu.length}"
                ?menu-already-active="${this._isMenuAlreadyActive}"
                selected-menu-item-name="${this.subMenuItem}"
                selected-right-tab="exchange"
                sub-menu-title="${this.routeElement}"
                with-accordion
        >

            ${this.leftMenu?.length > 0 && this.leftMenu.map((item) => html`
                <bd-app-header-top-left-item
                        class="top-left-item"
                        slot="top-left"
                        with-accordion
                        ?has-children=${item.menuItemLinks?.length > 0}
                        caption="${item.link.title}"
                        name="${item.link.title}"
                        ?active="${window.location.href.includes(item.link.url.link)}"
                        ?selected="${window.location.href.includes(item.link?.url?.link)}"
                        href="${ifDefined(!this.isTablet ? item.link.url.link ?? undefined :
                                ((!item.menuItemLinks || item.menuItemLinks?.length <= 0) &&
                                item.link.url.link ? item.link.url.link : undefined))}"
                        target="${item.link.url.target}"
                >
                    ${this.getMenuItems(item.menuItemLinks)}
                </bd-app-header-top-left-item>
            `)}

            ${this.rightMenu.map((item) => html`
                <bd-app-header-top-right-item
                        hide-in-burger
                        highlighted
                        slot="top-right"
                        href="${item.link.url.link}"
                        target="${item.link.url.target}"
                        caption="${item.link.title}"
                        icon="${item.icon}"
                        name="${item.link.title}"
                        ?active="${this.selectedSegment === item.link.title}"
                        @click="${this._headerClickHandler}"
                        @additional-icon-click="${() => this._goToSelectedPage(item.link.url.link)}"
                >
                </bd-app-header-top-right-item>
            `)}

            <a href="${this._logoLink(this.subMenu)}" slot="small-logo">
                <img width="100%" src="assets/logo-responsive.svg"/>
            </a>
            <a href="${this._logoLink(this.subMenu)}" slot="logo">
                <!--  <img src="assets/logo.svg"/>-->
                <img width="100%" src="assets/logo-responsive.svg"/>
            </a>

            <bd-button ?mini="${!this.isMobile}" slot="mini-search-bar"
                       class="become-solo-button"
                       @click="${this._goToBecomeSolo}">
                ${this.accountDictionary?.becomeSolo}
            </bd-button>

            <bd-account-switcher
                    class="account-switcher"
                    hide-account-status
                    slot="account-switcher"
                    isDropdown class="account-switcher"
                    ?signed="${this.isLoggedIn}"
                    .avatar="${this._getUserAvatar()}"
                    @click="${this._accountSwitcherClicked}"
            >

                <bd-product-switcher
                        class="product-switcher"
                        slot="additional-items"
                        client-channel="${this.userInfo?.client?.clientCategory}"
                        client-key="${this.userInfo?.client?.clientKey || ''}"
                        channels-title="${this.productSwitcherDictionary?.channelsTitle}"
                        webpages-title="${this.productSwitcherDictionary?.webpagesTitle}"
                        icon="bd:switch"
                        tooltip-text="${this.productSwitcherDictionary?.tooltipTitle}"
                        @click="${() => this._closeDrawerMenu(false)}"
                >
                </bd-product-switcher>

                <span slot="title">${this._getUserName(this.userInfo)}</span>

                ${!this.isLoggedIn && this.ibankLinks && this.ibankLinks.map((item) => html`
                    <a href="${item.link.url.link}" target="${item.link.url.target}" slot="dropdown"
                       @click="${() => this._sendAccountEvent(item.link.url.link)}">
                        <bd-list-item no-border class="ibank-link-item">
                            <bd-button
                                    class="content" type="text" slot="center">
                                ${item.link.title}
                            </bd-button>
                        </bd-list-item>
                    </a>
                `)}
                ${this.isLoggedIn ? html`
                    <bd-list-item slot="dropdown" static>
                        <bd-font type="button" slot="center">${this.accountDictionary?.settings}</bd-font>
                    </bd-list-item>

                    <a href="${this.accountDictionary?.accountUrl}" target="_blank" slot="dropdown">
                        <bd-list-item no-border>
                            <bd-button class="content" type="text" slot="center">${this.accountDictionary?.configUser}
                            </bd-button>
                        </bd-list-item>
                    </a>

                    <bd-button slot="footer" type="text" mini icon="log_out" @click=${this._logout}>
                        ${this.accountDictionary?.logOut}
                    </bd-button>
                ` : ``}
            </bd-account-switcher>


            ${this.langComponent()}
            ${this.getMenuItems(this.subMenu)}

        </bd-app-header>
        <bd-button ?mini="${!this.isTablet}"
                   class="floating-button"
                   @click="${this._goToBecomeSolo}">
            ${this.accountDictionary?.becomeSolo}
        </bd-button>

        ${this.pathEndpoints.items?.length > 0 ? this._getBreadcrumbsSchema() : ''}
    `;
  }


  getMenuItems(data = []) {
    return html`
        ${data?.length > 0 ? data.map((item, index, data) => index + 1 === data.length &&
        this.isXLaptop && !this.isTablet && item.menuItemLinks?.length > 0 ? html`
            ${item.menuItemLinks.map((elem, i) => html`
                ${elem.menuItemLinks.map((listItem, j) => listItem.link?.title ? html`
                    <bd-app-header-menu-item
                            id="${`app-header-menu-item-${i}_${j}`}"
                            class="app-header-menu-item"
                            slot="menu-item"
                            with-accordion
                            overlay-is-adaptive
                            overlay-centered
                            has-full-overlay
                            ?selected="${window.location.href.includes(listItem.link?.url?.link)}"
                            name="${listItem.link?.title}"
                            caption="${listItem.link?.title}"
                            href="${ifDefined(listItem.link?.url?.link &&
                            !(listItem.link.url.link.includes('more')) ? listItem.link.url.link : undefined)}"
                            @click="${this._overlayVisibility}"
                    >
                    </bd-app-header-menu-item>
                ` : '')}
            `)}
        ` : html`
            <bd-app-header-menu-item
                    id="${`app-header-menu-item-${index}`}"
                    class="app-header-menu-item"
                    slot="${this.isTablet ? 'children' : 'menu-item'}"
                    with-accordion
                    overlay-is-adaptive
                    overlay-centered
                    has-full-overlay
                    ?selected="${window.location.href.includes(item.link.url.link)}"
                    ?has-children=${item.menuItemLinks?.length > 0}
                    ?has-overlay-menu="${item.menuItemLinks?.length > 0}"
                    ?has-column-menu="${item.menuItemLinks?.length > 0}"
                    name="${item.link.title}"
                    caption="${item.link.title}"
                    href="${ifDefined(this.isTablet ? (item.link.url.link ?
                            item.link.url.link : undefined) : (item.link.url.link &&
                    !(item.link.url.link.includes('more')) ? item.link.url.link : undefined))}"
                    all-products-caption="${this.accountDictionary?.allProducts}"
                    @click="${this._overlayVisibility}"
                    @all-button-clicked="${() => this._goToSelectedPage(item.link?.url?.link)}"
                    @menu-open-changed="${() => this._closeDrawerMenu(item.menuItemLinks)}"
            >
                ${this.isTablet && item?.additionalButton?.title && item.additionalButton.url?.link ? html`
                    <bd-standard-button
                            class="additional-button"
                            type="secondary"
                            size="medium"
                            href="${item.additionalButton.url.link}"
                            target="${item.additionalButton.url.target}"
                            @click="${() => this._closeDrawerMenu(false)}"
                    >
                        ${item.additionalButton.title}
                    </bd-standard-button>
                ` : ''}

                ${item.menuItemLinks?.length > 0 ? html`
                    ${this.isTablet ? html`
                        ${item.menuItemLinks.map((elem) => html`
                            <bd-app-header-menu-item-list>
                                ${item.menuItemLinks?.length > 1 && elem.description ? html`
                                    <bd-list-item slot="title" class="menu-item-title"
                                                  @click="${() => this._goToSelectedPage(elem.link?.url?.link)}">
                                        <bd-font slot="center" type="number"> ${elem.description}</bd-font>
                                        ${this.isTablet && elem.link?.url?.link &&
                                        elem.menuItemLinks?.length > 0 ? html`
                                            <bd-icon
                                                    class="all-button-icon"
                                                    slot="right"
                                                    icon="bd:chevron_right"
                                            >
                                            </bd-icon>
                                        ` : ''}
                                    </bd-list-item>
                                ` : ``}

                                ${elem.menuItemLinks?.length ? elem.menuItemLinks.map((listItem) => html`
                                    <a
                                    slot="items"
                                    class="li-item-wrapper ${window.location.href?.includes(listItem.link?.url?.link) ?
                                    'selected' : ''}"
                                    href="${listItem.link?.url?.link}"
                                    target="${listItem.link?.url?.target}"
                                    @click="${() => this._closeDrawerMenu(false)}"
                                    id="sub-item"
                                    >
                                        <bd-list-item class="li-item menu-child-item">
                                            <bd-font slot="center" type="body2">${listItem.link.title}</bd-font>
                                        </bd-list-item>
                                    </a>
                                `) : ''}
                            </bd-app-header-menu-item-list>
                        `)}

                    ` : html`
                        <bd-app-header-menu-overlay
                                class="menu-overlay ${item.menuItemLinks?.length >= 4 ? 'col-4' :
                                        item.menuItemLinks?.length <= 1 ? 'col-2' :
                                                `col-${item.menuItemLinks.length}`}
                            ${item.banner?.title ? 'menu-overly-with-banner' : ''}"
                                is-platform
                                .value="${item.link.url.link}"
                        >

                            ${item.link?.title ? html`
                                <a slot="title" class="li-item-wrapper"
                                   href="${item.link.url.link}" target="${item.link.url.target}">
                                    <bd-list-item
                                            static
                                            class="li-item overlay-title-item"
                                    >
                                        <bd-font slot="center" type="h4">${item.link.title}</bd-font>
                                        <bd-icon slot="right" class="title-right-icon"
                                                 icon="bd:chevron_right"></bd-icon>
                                    </bd-list-item>
                                </a>
                            ` : ''}

                            ${item.menuItemLinks.map((elem) => html`
                                <bd-app-header-menu-overlay-column
                                        slot="column"
                                        title="${item.menuItemLinks?.length > 1 ? elem.description : ''}"
                                        title-type="subtitle">
                                    ${elem.menuItemLinks.map((listItem, index) => this._megaMenuItem(listItem, index))}
                                    ${elem.allProductsLink?.url ? html`
                                        <bd-button
                                                class="all-product-button"
                                                slot="button"
                                                href="${elem.allProductsLink.url.link}"
                                                target="${elem.allProductsLink.url.target}"
                                                type="text">
                                            ${elem.allProductsLink.title}
                                        </bd-button>
                                    ` : ''}
                                </bd-app-header-menu-overlay-column>
                            `)}

                            ${item.banner && item.menuItemLinks.length < 3 && html`
                                <a
                                        slot="banner"
                                        class="banner-wrapper"
                                        href="${ifDefined(item.banner?.url?.link ?? undefined)}"
                                        target="${ifDefined(item.banner?.url?.target ?? undefined)}"
                                >
                                    <bd-major-card
                                            class="banner"
                                            show-description
                                            type="${!item.banner?.vertical && !this.isLaptop ? 'right' : 'top'}"
                                    >
                                        <img slot="media" src="${item.banner?.image?.url}"
                                             alt="${item.banner?.image?.alt}">
                                        <bd-font slot="title" type="subtitle" fixed class="banner-title">
                                      <span>
                                          ${item.banner?.title}
                                      </span>
                                        </bd-font>
                                        ${item.banner?.description ? html`
                                            <bd-font slot="body" type="button-text" class="banner-description">
                                        <span>
                                          ${item.banner.description}
                                        </span>
                                            </bd-font>
                                        ` : ''}
                                        ${item.banner?.url?.link ? html`
                                            <bd-standard-button
                                                    slot="bottom"
                                                    type="text-low"
                                                    size="small">
                                                ${item.banner.buttonTitle}
                                            </bd-standard-button>
                                        ` : ''}
                                    </bd-major-card>
                                </a>
                            `}
                        </bd-app-header-menu-overlay>
                    `}

                ` : ``}

            </bd-app-header-menu-item>
        `) : ''}
    `;
  }

  langComponent() {
    return html`
        ${this.isTablet ? html`
            <bd-list-item class="lang-item" slot="lang-bar">
                <bd-icon slot="left" class="lang-icon" icon="bd:language"
                         @click="${this._changeLangFromList}"></bd-icon>
                ${this._langSelector(true)}
            </bd-list-item>
        ` : html`
            ${this._langSelector()}
        `}
    `;
  };

  _langSelector(inList = false) {
    return html`
        <bd-language-selector
                class="language-selector"
                small
                type="toggle"
                orientation="topCenter"
                slot="${inList ? 'center' : 'lang-bar'}"
                @language-change="${this._languageChange}">
            ${this.langArray.map((lang) => html`
                <bd-language-selector-item
                        ?selected="${lang.value !== this.selectedLanguage}"
                        name="${lang.caption}"
                        short-name="${lang.shortName}"
                        value="${lang.value}">
                </bd-language-selector-item>
            `)}
        </bd-language-selector>
    `;
  }

  static get properties() {
    return {
      leftMenu: {
        type: Array,
      },
      rightMenu: {
        type: Array,
      },
      selectedSegment: {
        type: String,
        attribute: 'selected-segment',
      },
      subMenu: {
        type: Array,
      },
      subMenuItem: {
        type: String,
      },
      megaMenuSelectedItem: {
        type: String,
      },
      route: {
        type: String,
      },
      mainRouteData: {
        type: Object,
      },
      mainRouteTail: {
        type: Object,
      },
      routeData: {
        type: Object,
      },
      routeTail: {
        type: Object,
      },
      ibankLinks: {
        type: Array,
      },
      isLoggedIn: {
        type: Boolean,
      },
      isUserLoading: {
        type: Boolean,
      },
      userInfo: {
        type: Object,
      },
      langArray: {
        type: Array,
      },
      selectedLanguage: {
        type: String,
      },
      searchDictionary: {
        type: Object,
      },
      routeElement: {
        type: String,
      },
      becomeSoloApplication: {
        type: Object,
      },
      pathEndpoints: {
        type: Object,
      },
      iconImage: {
        type: Object,
      },
      hasIconImage: {
        type: Boolean,
      },
      hideHeader: {
        type: Boolean,
        reflect: true,
        attribute: 'hide-header',
      },
    };
  }

  constructor() {
    super();
    this.hideHeader = false;
    this.leftMenu = [];
    this.rightMenu = [];
    this.subMenu = [];
    this.ibankLinks = [];
    this.route = '';
    this.mainRouteData = {};
    this.mainRouteTail = {};
    this.routeData = {};
    this.routeTail = {};
    this.userInfo = {};
    this.selectedSegment = '';
    this.subMenuItem = '';
    this.megaMenuSelectedItem = '';
    this.isLoggedIn = false;
    this.isUserLoading = false;
    this.routeElement = '';
    this.pathEndpoints = {};
    this.langArray = [
      {
        name: 'ქართული',
        shortName: 'Geo',
        value: 'ka',
      },
      {
        name: 'English',
        shortName: 'Eng',
        value: 'en',
      },
    ];
    this.selectedLanguage = '';

    this._onLoggedIn = () => {
      this.getUserInfo();
    };

    this._onLoggedFailed = () => {
      try {
        if (localStorage.userInfo) {
          const userInfo = JSON.parse(localStorage.userInfo);
          this.userInfo = userInfo;
        }
      } catch (err) {
        console.log(err);
      }
    };
  }

  connectedCallback() {
    super.connectedCallback();
    this._getMenuData();

    window.addEventListener('logged-in', this._onLoggedIn);
    window.addEventListener('logged-failed', this._onLoggedFailed);

    window.dispatchEvent(new CustomEvent('header-ready', {
      bubbles: true,
    }));

    this.selectedLanguage = localStorage.getItem('lang') || 'ka';
    this.shadowRoot.addEventListener('click', this._onMenuClick.bind(this));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('logged-in', this._onLoggedIn);
    window.removeEventListener('logged-failed', this._onLoggedFailed);
    this.shadowRoot.removeEventListener('click', this._onMenuClick.bind(this));
  }

  _getMenuData() {
    this.apiCall('header/menu/5e4d1dc37f8e9a0352df28ba')
      .then((res) => {
        this.leftMenu = this.isTablet && res.json.data?.menuContent?.leftMenuItemsMobile ?
          res.json.data.menuContent.leftMenuItemsMobile : res.json.data.menuContent.leftMenuItems;
        this.rightMenu = res.json.data.menuContent.rightMenuItems;
        this.ibankLinks = res.json.data.menuContent.ibankLinks;
        this.searchDictionary = res.json.data.menuContent.searchDictionary;
        this.accountDictionary = res.json.data.menuContent.accountDictionary;
        this.becomeSoloApplication = res.json.data.menuContent.becomeSoloApplication;
        this.productSwitcherDictionary = res.json.data.menuContent.productMenuDictionary;
        this.iconImage = res.json.data.menuContent.iconImage;
        this.hasIconImage = res.json.data.menuContent.hasIconImage;
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getUserInfo() {
    this.isUserLoading = true;
    this.apiCall(`auth/info`)
      .then((res) => {
        this.userInfo = res.json;
        this.isLoggedIn = true;
        this.isUserLoading = false;
        try {
          const {categoryType, firstName, lastName, sex, clientKey} = res.json.client;
          localStorage.setItem('userInfo', JSON.stringify({categoryType, firstName, lastName, sex, clientKey}));
        } catch (err) {
          console.log(err);
        }
      })
      .catch((err) => {
        this.isUserLoading = true;
        this.isLoggedIn = err.status !== 401;
        console.error(err);
      });
  };

  _onMenuClick(event) {
    const path = event.composedPath ? event.composedPath() : (event.path || []);
    path.some((item) => {
      if (item.nodeType === Node.ELEMENT_NODE && item.tagName) {
        if (item.tagName.toLowerCase() === 'bd-product-switcher-item') {
          const titleElement = item.shadowRoot.querySelector('.title');
          if (titleElement) {
            const titleText = titleElement.textContent.trim();
            // eslint-disable-next-line max-len
            this.sendAnalyticsEvent(`product_switcher_button_click`, `${titleText.replaceAll(' ', '_')}`, `product_switcher`, false, true);
          }
          return true;
        }

        if (item.tagName.toLowerCase() === 'bd-app-header-top-left-item') {
          this._headerClickHandler(item.name, true);

          if (this.isTablet && !item.hasAttribute('has-children')) {
            this.shadowRoot.querySelector('bd-app-header').shadowRoot
              .querySelector('bd-app-header-drawer').removeAttribute('is-open');
            document.documentElement.classList.remove('no-scroll');
          }
        }
      }
    });
  }

  // This need new solution. couldn't find different way -_-
  _overlayVisibility(e) {
    if (this.isTablet) return;
    const allMenuItems = this.shadowRoot.querySelectorAll('.app-header-menu-item');
    const elementNode = e?.currentTarget;
    if (!e) {
      setTimeout(() => {
        allMenuItems.forEach((element) => {
            if (element.hasAttribute('has-children') &&
              element.hasAttribute('invisible')) {
              element.removeAttribute('invisible');
            }
          },
        );
      }, 10);
    } else if (elementNode && elementNode.hasAttribute('has-children')) {
      elementNode.setAttribute('invisible', '');
      setTimeout(() => {
        elementNode.removeAttribute('invisible');
      }, 10);
    }
  }


  willUpdate(prop) {
    if (prop.has('route') || prop.has('leftMenu')) {
      this._setSelectedItems();
      this._overlayVisibility();
    }
  }

  _setSelectedItems() {
    if (!this.route || !this.leftMenu || !this.leftMenu.length) {
      return;
    }
    if (this.route === '/') {
      const first = this.leftMenu[0];
      this.route = first.link.url.link;
      history.replaceState(null, null, this.route);
    }
    const route = this._formatRoute(this.route);
    const routes = this._findLinkNode(route);
    if (!routes) {
      return;
    }
    const segmentNode = routes.segment;
    const subMenuItemNode = routes.subMenuItem;
    const megaMenuItem = routes.megaMenuItem;

    this.routeElement = segmentNode.link.title;

    if (segmentNode.menuItemLinks && segmentNode.menuItemLinks.length) {
      segmentNode.menuItemLinks.forEach((item) => {
        if (window.location.href.includes(item.link.url.link)) {
          this.selectedSegment = item.link.title;
        }
      });
    } else {
      this.selectedSegment = segmentNode?.link?.title ?? '';
    }

    this.subMenu = segmentNode?.menuItemLinks ? segmentNode.menuItemLinks : [];

    if (subMenuItemNode) {
      this.subMenuItem = subMenuItemNode.link.title;
    }

    if (megaMenuItem) {
      this.megaMenuSelectedItem = megaMenuItem.link.title;
    } else {
      this.megaMenuSelectedItem = '';
    }
  }


  _findLinkNode(route) {
    const routes = {};
    const segmentFound = [...this.leftMenu, ...this.rightMenu].find((item) =>
      item.link.url.link === route.segmentLink.toLowerCase());

    if (!segmentFound) {
      return routes;
    }
    routes.segment = segmentFound;
    const subItemFound = segmentFound.menuItemLinks &&
      segmentFound.menuItemLinks.find((item) => item.link.url.link === route.subMenuLink);

    if (!subItemFound) {
      return routes;
    }
    routes.subMenuItem = subItemFound;

    let megaMenuItemFound = null;
    const linksArray = subItemFound.menuItemLinks || [];
    for (const item of linksArray) {
      const found = this._findMegaMenuMatch(item, route.megaMenuLink);
      if (!found) {
        continue;
      }
      megaMenuItemFound = found;
      break;
    }
    if (!megaMenuItemFound) {
      return routes;
    }

    routes.megaMenuItem = megaMenuItemFound;
    return routes;
  }

  _findMegaMenuMatch(item, link) {
    const arr = item.menuItemLinks;
    const found = arr.find((elem) => elem.link.url.link === link);
    return found;
  }

  _formatRoute(route) {
    const arr = route.split('/');
    let segmentLink = '';
    let subMenuLink = '';
    let megaMenuLink = '';
    for (let i = 1; i <= 2; ++i) {
      if (arr[i]) {
        segmentLink = `${segmentLink}/${arr[i]}`;
      }
    }
    if (arr[3]) {
      subMenuLink = `${segmentLink}/${arr[3]}`;
    }
    if (arr[4]) {
      megaMenuLink = `${subMenuLink}/${arr[4]}`;
    }
    const obj = {
      segmentLink,
      subMenuLink,
      megaMenuLink,
    };
    return obj;
  }

  _logoLink(menu) {
    return menu && menu[0] && menu[0].link && menu[0].link.url ?
      menu[0].link.url.link :
      '/';
  }

  _logout() {
    this.dispatchEvent(new CustomEvent('logout', {bubbles: true, composed: true}));
  }

  _languageChange(e) {
    if (e.detail && localStorage.getItem('lang') === e.detail) {
      const currentLangIndex = config.languages.indexOf(e.detail);
      const lang = config.languages[currentLangIndex + 1] ?
        config.languages[currentLangIndex + 1] : config.languages[0];
      localStorage.setItem('lang', lang);
      const path = location.pathname.split('/');
      path[1] = lang;
      location.pathname = path.join('/');
    }
  }

  _getUserAvatar() {
    if (!this.isLoggedIn || !this.userInfo) {
      if (this.iconImage?.url && this.hasIconImage) {
        return this.iconImage.url;
      }
      return null;
    }
    return `${config.apiEndpoint}auth/avatar/?${this.userInfo?.clientAvatar?.imageUrl}`;
  }

  _changeLangFromList(e) {
    const langSelector = e.currentTarget?.children?.[1] || this.shadowRoot.querySelector('bd-language-selector');
    langSelector._toggle();
  };

  _getUserName(userInfo) {
    const {client} = userInfo;
    if (!client) {
      return this.accountDictionary?.ibank;
    }

    return `${client.firstName} ${client.lastName}`;
  }

  _megaMenuItem(item, index) {
    if (!item?.link?.title) return;
    return html`
        <a
                class="mega-menu-item li-item-wrapper"
                href="${item.link.url.link}" slot="item"
                target="${item.link.url.target}">
            <bd-list-item
                    class="li-item ${this.megaMenuSelectedItem === item.link.title ? 'selected' : ''}"
                    id="menu-li-item-${index}">
                <bd-font slot="center" type="button-text">
                    ${item.link.title}
                </bd-font>
            </bd-list-item>
        </a>
    `;
  }

  _goToSelectedPage(url) {
    if (!url) return;
    try {
      history.pushState(null, null, url);
      window.dispatchEvent(new PopStateEvent('popstate'));
    } catch {
      window.open(url);
    }
    this._closeDrawerMenu(false);
  }

  _accountSwitcherClicked(e) {
    if (!this.isTablet) return;
    const drawerIsOpen = this.shadowRoot.querySelector('bd-app-header').shadowRoot
      .querySelector('bd-app-header-drawer').hasAttribute('is-open');
    if (e.target?.active) {
      document.documentElement.classList.add('no-scroll');
    } else if (!drawerIsOpen) {
      document.documentElement.classList.remove('no-scroll');
    }
  }

  _closeDrawerMenu(item) {
    if ((this.isTablet && !item) || (item && !item.length)) {
      const allSubItems = this.shadowRoot.querySelectorAll('#sub-item');
      const allMenuItems = this.shadowRoot.querySelectorAll('.app-header-menu-item');
      setTimeout(() => {
        allSubItems.forEach((elem) => {
          if (window.location.href.includes(elem.href)) {
            elem.classList.add('selected');
          } else {
            elem.classList.remove('selected');
          }
        });
        allMenuItems.forEach((elem) => {
          if (window.location.href.includes(elem.href)) {
            elem.expanded = true;
          } else {
            elem.expanded = false;
            elem.open = false;
          }
          elem._updateMaxHeight(!elem.expanded);
        });
      }, 0);

      this.shadowRoot.querySelector('bd-app-header').shadowRoot
        .querySelector('bd-app-header-drawer').removeAttribute('is-open');
      document.documentElement.classList.remove('no-scroll');
    }
  }

  _getClass(colorBreadcrumb) {
    return colorBreadcrumb ? 'colored' : '';
  }

  _sendAccountEvent(link) {
    if (link.includes('ibank.bog')) {
      this.sendAnalyticsEvent('account_switcher', '', 'ibank_redirect', false, true);
    } else if (link.includes('bonline.ge')) {
      this.sendAnalyticsEvent('account_switcher', '', 'bonline_redirect', false, true);
    }
  }

  _headerClickHandler(e, isName = false) {
    const name = isName ? e : e.target.caption;
    if (!name) return;
    this.sendAnalyticsEvent(`navigate_from_header_${name?.replaceAll(' ', '_')}`,
      ``, `navigation`, false, true);
  }

  _goToBecomeSolo() {
    window.history.pushState(null, null, `${window.location.origin}/${this.lang}/solo/become-solo`);
    window.dispatchEvent(new PopStateEvent('popstate'));
  }

  _getBreadcrumbsSchema() {
    const itemsSchema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      'itemListElement': [],
    };
    this.pathEndpoints.items.map((item, i) => {
      itemsSchema.itemListElement.push(
        {
          '@type': 'ListItem',
          'position': i + 1,
          'item': {
            '@id': item.link,
            'name': item.name,
          },
        });
    });
    const schemaItem = document.getElementById('bread-crumbs-schema-markup');
    if (schemaItem) {
      schemaItem.remove();
    }
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'bread-crumbs-schema-markup';
    script.innerHTML = JSON.stringify(itemsSchema);
    document.getElementsByTagName('head')[0].appendChild(script);
  }
}

window.customElements.define(SoloHeaderWrapper.is, SoloHeaderWrapper);
